import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DentalChart from '../../components/dental/DentalChart';
import {
    CHILD_LOWER_ROW,
    CHILD_UPPER_ROW,
    LOWER_ROW,
    UPPER_ROW,
} from '../../components/dental/teeth';
import { findToothByFdi, toothFdi } from '../../services/technicianRequestService';

export default function ToothPicker({ teethList = [], value, onChange }) {
    const { t } = useTranslation();
    const [type, setType] = useState('adult');
    const [fdi, setFdi] = useState(null);
    const isChild = type === 'child';

    useEffect(() => {
        if (value == null || value === '') return;
        const rec = (teethList || []).find((item) => Number(item.id) === Number(value));
        if (!rec) return;
        const number = toothFdi(rec);
        if (number) setFdi(number);
        setType(rec.type === 'child' ? 'child' : 'adult');
    }, [value, teethList]);

    useEffect(() => {
        if (fdi == null) return;
        const rec = findToothByFdi(teethList, fdi, type);
        if (!rec) return;
        const id = Number(rec.id);
        if (Number(value) !== id) onChange(id);
    }, [teethList, fdi, type, value, onChange]);

    const handleToggle = (nextFdi) => {
        const n = Number(nextFdi);
        if (fdi === n) {
            setFdi(null);
            onChange(null);
            return;
        }
        setFdi(n);
        const rec = findToothByFdi(teethList, n, type);
        onChange(rec ? Number(rec.id) : null);
    };

    return (
        <div>
            <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                <label className="text-sm font-medium text-slate-700">
                    {t('techRequest.tooth')}
                    <span className="ml-1 font-normal text-slate-400">({t('techRequest.toothOptional')})</span>
                </label>
                <div className="flex items-center gap-2">
                    <div className="flex rounded-lg border border-slate-200 bg-slate-50 p-0.5">
                        {['adult', 'child'].map((item) => (
                            <button
                                key={item}
                                type="button"
                                onClick={() => {
                                    setType(item);
                                    setFdi(null);
                                    onChange(null);
                                }}
                                className={`rounded-md px-2.5 py-1 text-xs font-semibold ${
                                    type === item ? 'bg-[#1D2C7B] text-white' : 'text-slate-600 hover:bg-white'
                                }`}
                            >
                                {item === 'child' ? t('techRequest.childTeeth') : t('techRequest.adultTeeth')}
                            </button>
                        ))}
                    </div>
                    {fdi ? (
                        <button
                            type="button"
                            className="text-xs font-semibold text-slate-500 hover:text-[#1D2C7B]"
                            onClick={() => {
                                setFdi(null);
                                onChange(null);
                            }}
                        >
                            {t('common.clear')}
                        </button>
                    ) : null}
                </div>
            </div>
            <DentalChart
                selected={fdi ? [fdi] : []}
                onToggle={handleToggle}
                upperRow={isChild ? CHILD_UPPER_ROW : UPPER_ROW}
                lowerRow={isChild ? CHILD_LOWER_ROW : LOWER_ROW}
                showRemarksLegend={false}
                showTooltip={false}
            />
            {fdi ? (
                <p className="mb-0 mt-2 text-sm text-slate-600">
                    {t('techRequest.tooth')}: <strong className="tabular-nums text-[#1D2C7B]">{fdi}</strong>
                </p>
            ) : null}
        </div>
    );
}
